



















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../system/mixins";
import { ScrollIntoView } from "../../system/utilities";
import { DocumentStructureEditableMixin, DocumentPageNavigatableMixin } from "./mixins";
import FormatSectionThumbnailViewer from "./FormatSectionThumbnailViewer.vue";

@Component({
  components: {
    FormatSectionThumbnailViewer,
  },
})
export default class DocumentPageSelector extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, DocumentPageNavigatableMixin, PdfStyleDrawableMixin) {
  @Prop()
  width: number;

  @Prop()
  indicatorFontSize: number;

  get pageSizeStyle(): any {
    return {
      width: "100%",
      height: this.width + "px",
    };
  }

  mounted(): void {
    this.scrollIntoView();
  }

  @Watch("currentPage")
  onCurrentPageChanged(newValue: number, oldValue: number): void {
    this.scrollIntoView();
  }

  scrollIntoView(): void {
    ScrollIntoView.vertical(this.$refs.root as Element, this.currentPage - 1);
  }

  onPageThumbnailClicked(pageNumber: number): void {
    if (!this.isSourceAlreadyInitialized) {
      this.$logger.info("初期化が終わっていないので、ページ選択できません。");
      return;
    }
    this.currentPage = pageNumber;
  }
}
